module.exports = __webpack_public_path__ + "img/icn_benefit5.2edbd139.svg";